export default function removeAllSlides() {
  const swiper = this;

  const slidesindexes = [];
  for (let i = 0; i < swiper.slides.length; i += 1) {
    slidesindexes.push(i);
  }
  swiper.removeSlide(slidesindexes);
}
